export default class BPrintButton
{
	static selector = () => `.print-button`;

	static initialize()
	{
		window.addEventListener("load", event => {
			document.querySelectorAll(this.selector()).forEach(el => {
				el.disabled = false;
			});
		});

		document.addEventListener("click", event => {
			if (event.target.matches(this.selector())) {
				window.print();
			}
		});
	}
}
